import { useRef, useState } from "react";
import { CheckCircle2, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";

const Fila = ({ req, doc, subir, busy }) => {
  const inp = useRef(null);
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-[#E2DDD5] bg-white p-4" data-testid={`alta-doc-${req.tipo}`}>
      {doc ? <CheckCircle2 className="shrink-0 text-[#2F7D4F]" size={20} /> : <Upload className="shrink-0 text-[#A8A196]" size={20} />}
      <div className="min-w-0 flex-1"><p className="text-sm font-semibold">{req.l}</p><p className="truncate text-xs text-[#8C867A]">{doc ? doc.nombre : "PDF, JPG o PNG · máx. 10 MB"}</p></div>
      <input ref={inp} type="file" accept="application/pdf,image/jpeg,image/png" className="hidden" onChange={(e) => e.target.files[0] && subir(req.tipo, e.target.files[0])} data-testid={`alta-doc-input-${req.tipo}`} />
      <button type="button" disabled={busy} onClick={() => inp.current.click()} className="rounded-full border border-[#111] px-4 py-1.5 text-xs font-semibold transition-colors hover:bg-[#111] hover:text-white disabled:opacity-40" data-testid={`alta-doc-btn-${req.tipo}`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : doc ? "Reemplazar" : "Subir"}</button>
    </div>
  );
};

export const PasoDocs = ({ alta, b, onAlta }) => {
  const [busy, setBusy] = useState("");
  const subir = (tipo, f) => {
    if (f.size > 10 * 1024 * 1024) return toast.error("El archivo excede 10 MB");
    const fd = new FormData(); fd.append("tipo", tipo); fd.append("archivo", f);
    setBusy(tipo);
    http.post(`/alta-ref/borrador/${b.id}/docs?t=${b.t}`, fd).then((r) => { onAlta(r.data); toast.success("Documento recibido"); }).catch((e) => toast.error(errMsg(e))).finally(() => setBusy(""));
  };
  const docsOk = alta.requeridos.filter((q) => q.req).every((q) => alta.docs.some((d) => d.tipo === q.tipo));
  return (
    <div className="space-y-3" data-testid="alta-docs" data-ok={docsOk ? "1" : "0"}>
      {alta.requeridos.map((q) => <Fila key={q.tipo} req={q} doc={alta.docs.find((d) => d.tipo === q.tipo)} subir={subir} busy={busy === q.tipo} />)}
      <p className="text-xs text-[#8C867A]">Sube una foto de cada lado o un PDF con ambos lados. Tu identificación se guarda cifrada y solo la revisa el equipo de Trafalgar.</p>
    </div>
  );
};
